import { NgModule } from '@angular/core';

import { InputModule } from '@xanadu/input';

import { TextMetaComponent } from './text-meta/text-meta.component';
import { NumberMetaComponent } from './number-meta/number-meta.component';
import { CommonMetaComponent } from './common-meta/common-meta.component';
import { AreaMetaComponent } from './area-meta/area-meta.component';
import { SliderMetaComponent } from './slider-meta/slider-meta.component';
import { SelectMetaComponent } from './select-meta/select-meta.component';
import { OptionMetaComponent } from './option-meta/option-meta.component';
import { PickerMetaComponent } from './picker-meta/picker-meta.component';
import { ImageMetaComponent } from './image-meta/image-meta.component';
import { DictionaryMetaComponent } from './dictionary-meta/dictionary-meta.component';
import { FormulaMetaComponent } from './formula-meta/formula-meta.component';

@NgModule({
  declarations: [
    TextMetaComponent,
    NumberMetaComponent,
    CommonMetaComponent,
    AreaMetaComponent,
    SliderMetaComponent,
    SelectMetaComponent,
    OptionMetaComponent,
    PickerMetaComponent,
    ImageMetaComponent,
    DictionaryMetaComponent,
    FormulaMetaComponent
  ],
  imports: [
    InputModule
  ],
  exports: [
  ]
})
export class MetaModule { }

export * from '../meta/text-meta/text-meta.component';
export * from '../meta/number-meta/number-meta.component';
export * from '../meta/common-meta/common-meta.component';
export * from '../meta/area-meta/area-meta.component';
export * from '../meta/slider-meta/slider-meta.component';
export * from '../meta/select-meta/select-meta.component';
export * from '../meta/option-meta/option-meta.component';
export * from '../meta/image-meta/image-meta.component';
export * from '../meta/picker-meta/picker-meta.component';
export * from '../meta/dictionary-meta/dictionary-meta.component';
export * from '../meta/formula-meta/formula-meta.component';
